import { Api } from './axios-config';

export interface ScheduleDay {
  id: number;
  businessId?: number;
  businessEmployeeId?: number;
  dayOfWeek: number;
  dayName: string;
  isClosed: boolean;
  startTime?: string | null;
  endTime?: string | null;
}

export interface ServicePublic {
  id: number;
  description: string;
  amount: number;
}

export interface EmployeePublic {
  id: number;
  name: string;
  color: string;
  profilePicture: string | null;
  schedules: ScheduleDay[];
}

export interface Holiday {
  id: number;
  businessId: number;
  date: string;
  description: string;
}

export interface BusinessPublicView {
  id: number;
  name: string;
  slug: string;
  address: string;
  profilePicture: string | null;
  phone?: string;
  instagram?: string;
  facebook?: string;
  website?: string;
  paymentMethods?: string;
  weeklySchedules?: ScheduleDay[];
  services: ServicePublic[];
  employees: EmployeePublic[];
  holidays: Holiday[];
}

const getBySlug = async (slug: string): Promise<BusinessPublicView> => {
  const { data } = await Api.get<BusinessPublicView>(
    `/api/public/${slug}`
  );
  return data;
};

export interface WhatsAppContact {
  phoneNumber: string;
}

const getWhatsAppContact = async (): Promise<WhatsAppContact> => {
  const { data } = await Api.get<WhatsAppContact>(
    '/api/public/whatsapp-contact'
  );
  return data;
};

export const publicService = {
  getBySlug,
  getWhatsAppContact,
};
